import { useState } from 'react'
import { Button } from '../../../components/ui/button'
import { Card } from '../../../components/ui/card'
import { importEventFromLuma } from '../../../services/LumaScraperService'

interface ImportFromLumaModalProps {
  isOpen: boolean
  onClose: () => void
  userId: string
  userProfile?: { name?: string; email?: string; avatarUrl: string }
  onImported?: (eventId: string) => void
}

export const ImportFromLumaModal = ({ isOpen, onClose, userId, userProfile, onImported }: ImportFromLumaModalProps) => {
  const [url, setUrl] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (!isOpen) return null

  const handleImport = async () => {
    setIsLoading(true)
    setError(null)
    try {
      const { eventId, error } = await importEventFromLuma(url.trim(), userId, userProfile)
      if (error) {
        setError(error)
      } else if (eventId) {
        onClose()
        if (onImported) onImported(eventId)
      }
    } finally {
      setIsLoading(false)
    }
  }

  const isValid = /^https?:\/\//i.test(url) && (/lu\.ma/i.test(url) || /luma/i.test(url))

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <Card className="w-full max-w-lg mx-4 p-6">
        <div className="mb-4">
          <h2 className="text-xl font-semibold">Import from Luma</h2>
          <p className="text-sm text-gray-600 mt-1">Paste the public URL of the event from Luma.</p>
        </div>

        <div className="space-y-3">
          <label className="block text-sm font-medium">Event URL</label>
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://luma/your-event or https://lu.ma/your-event"
            className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
          />

          {error && (
            <div className="text-sm text-red-600">{error}</div>
          )}
        </div>

        <div className="mt-6 flex gap-3">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>Cancel</Button>
          <Button onClick={handleImport} disabled={!isValid || isLoading} className="bg-accent text-white hover:bg-accent/90">
            {isLoading ? 'Importing…' : 'Import'}
          </Button>
        </div>
      </Card>
    </div>
  )
}


